import React from 'react';
import { MDBWysiwyg } from 'mdb-react-wysiwyg';

const Editor = ({ value, onChange }) => {
    return (
        <MDBWysiwyg
            value={value}
            onChange={onChange}
            style={{ minHeight: '200px' }}
        />
    );
}
export default Editor;